import React from "react";
import { useState, useEffect, useContext } from "react";
import http from "../../services/http-commons.js";
import OrderNoTransaction from "./OrderNoTransaction.js";
import { SetAllContext } from "../../services/AllContext.js";
import Logo from "../../assets/BankeMainLogo.png";
import { useNavigate } from "react-router-dom";

import "./Order.scss";

const Order = () => {
  const navigate = useNavigate();
  const { userID, setOrderId } = useContext(SetAllContext);

  // ==================== State =========================
  const [getOrders, setGetOrders] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [errorCode, setErrorCode] = useState(null);

  // =================== Effects =================
  useEffect(() => {
    setLoading(true);
    setError(null);
    setErrorCode(null);

    http.ORDERHTTP.get(`/orders`)
      .then((response) => {
        setGetOrders(response.data);
      })
      .catch((error) => {
        console.log("ERROR", error);

        if (error.response) {
          // Server responded but with error status
          if (error.response.status === 404) {
            setError("No orders found.");
            setErrorCode(404);
          } else if (error.response.status === 500) {
            setError(
              "Something went wrong on the server. Please try again later.",
            );
            setErrorCode(500);
          } else if (error.response.status === 401) {
            setError("Unauthorized. Please log in to continue.");
            setErrorCode(401);
          } else {
            setError(
              error.response.data?.detail ||
                "An unexpected error occurred. Please try again.",
            );
            setErrorCode(error.response.status);
          }
        } else if (error.request) {
          // No response from server
          setError("No response from server. Check your connection.");
        } else {
          // Something else
          setError(`Error: ${error.message}`);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, [userID]);

  // =================== Functions =================

  function formatDate(dateString) {
    if (!dateString) return "";

    const date = new Date(dateString);

    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
    };

    const timeOptions = {
      hour: "2-digit",
      minute: "2-digit",
    };

    return `${date.toLocaleDateString(
      undefined,
      options,
    )} at ${date.toLocaleTimeString(undefined, timeOptions)}`;
  }

  function openOrderItem(orderId) {
    setOrderId(orderId);
    navigate("/profile/order-items");
  }

  // =================== Loading ===================

  if (loading) {
    return (
      <div className="order-state-container">
        <div className="order-loader"></div>
        <p>Loading your orders...</p>
      </div>
    );
  }

  // =================== Login Required ===================

  if (errorCode === 401) {
    return (
      <div className="order-state-container">
        <div className="order-state-card">
          <div className="order-state-icon">🔐</div>

          <h2>Login Required</h2>

          <p>
            Please log in to your Banke account to view your orders and track
            your purchases.
          </p>

          <button
            className="order-login-btn"
            onClick={() => navigate("/auth/login")}
          >
            Log In
          </button>
        </div>
      </div>
    );
  }

  // =================== Other Errors ===================

  if (error) {
    return (
      <div className="order-state-container">
        <div className="order-state-card">
          <div className="order-state-icon">⚠️</div>

          <h2>Something went wrong</h2>

          <p>{error}</p>

          <button
            className="order-login-btn"
            onClick={() => window.location.reload()}
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  // =================== Orders ===================

  return (
    <div className="order-trans">
      <div className="order-trans-buttons">
        <button
          className="btn btn-primary col-12"
          style={{ marginRight: "3px" }}
        >
          Orders
        </button>
      </div>

      {getOrders?.length > 0 ? (
        getOrders.map((item, index) => (
          <div key={index} className="order-trans-content">
            <div
              className="order-trans-items"
              onClick={() => openOrderItem(item.id)}
              style={{ cursor: "pointer" }}
            >
              <div className="col-md-3 order-trans-items-img">
                <img
                  src={Logo}
                  alt="logo"
                  style={{
                    width: "100px",
                    height: "100px",
                  }}
                />
              </div>

              <div className="col-md-7 order-trans-items-product">
                <h6>{item?.status || ""}</h6>

                <p>
                  <strong>Ordered date:</strong>{" "}
                  <em>{formatDate(item?.order_date)}</em>
                </p>

                <p>
                  <strong>
                    Mobile line:{" "}
                    <em>{item?.deliveries?.mobile_number || ""}</em>
                  </strong>
                </p>
              </div>

              <div className="col-md-2 d-flex justify-content-center align-items-center">
                <p>
                  <strong>₦{item?.total_amount?.toLocaleString() || ""}</strong>
                </p>
              </div>
            </div>
          </div>
        ))
      ) : (
        <OrderNoTransaction />
      )}
    </div>
  );
};

export default Order;
